import { useQuery } from '@tanstack/react-query';
import { mockApi } from '@/core/services/api';

export const useChartData = (cameraId: string, isCounting: boolean) => {
  return useQuery({
    queryKey: ['chart', cameraId],
    queryFn: () => mockApi.getChartData(cameraId),
    enabled: !!cameraId,
    structuralSharing: true, // Reuse unchanged data points to prevent unnecessary rerenders
    refetchInterval: isCounting ? 1000 : false, // Refetch every 1 second when counting (real-time stock chart style)
  });
};

export const useHistoryData = (cameraId: string, isCounting: boolean) => {
  return useQuery({
    queryKey: ['history', cameraId],
    queryFn: () => mockApi.getHistoryRecords(cameraId),
    enabled: !!cameraId,
    structuralSharing: true, // Reuse unchanged history records to prevent unnecessary rerenders
    refetchInterval: isCounting ? 1000 : false, // Refetch every 1 second when counting
  });
};

export const useHistoryChartData = (recordKey: string | null) => {
  return useQuery({
    queryKey: ['historyChart', recordKey],
    queryFn: () => mockApi.getHistoryChartData(recordKey!),
    enabled: !!recordKey,
    staleTime: 60000, // Cache for 60 seconds - history data doesn't change frequently
    refetchOnMount: false, // Don't refetch if already cached
    gcTime: 300000, // Keep unused queries for 5 minutes
  });
};
